var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6963 7.26178L11.8347 0.400059C11.6389 0.204191 11.3778 0.0966797 11.0995 0.0966797C10.8208 0.0966797 10.5599 0.204345 10.364 0.400059L9.74105 1.02319C9.54534 1.21875 9.43752 1.47996 9.43752 1.75847C9.43752 2.03683 9.54534 2.30684 9.74105 2.5024L13.744 6.51415H1.02645C0.453061 6.51415 0 6.96304 0 7.53658V8.41753C0 8.99108 0.453061 9.48523 1.02645 9.48523H13.7894L9.7412 13.5194C9.54549 13.7152 9.43767 13.9693 9.43767 14.2479C9.43767 14.5261 9.54549 14.7839 9.7412 14.9796L10.3642 15.6007C10.5601 15.7966 10.821 15.9033 11.0996 15.9033C11.378 15.9033 11.639 15.7952 11.8349 15.5993L18.6965 8.73774C18.8928 8.54126 19.0008 8.27897 19 8.00015C19.0006 7.7204 18.8928 7.45796 18.6963 7.26178Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.fb21d90f83a62ca86dbee981fdfbd8dc.svg";
export { ForwardRef as ReactComponent };